import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { TAB_NAMES } from 'components/pages/Templates/model'
import { toTemplates } from 'ducks/router'
import { useTable } from 'hooks'
import { templates } from 'orm'
import { getColumns, getRowActions } from './model'
import type { TableQuery } from 'hooks/useTable'

const useMessagesTableMutations = () => {
  const dispatch = useDispatch()

  const handleFetchMessagesTemplates = React.useCallback(
    ({ limit, department, offset, ordering, search }: TableQuery) => {
      dispatch(
        templates.fetchStart({ limit, department, offset, ordering, search }),
      )
    },
    [dispatch],
  )

  return {
    handleFetchMessagesTemplates,
  }
}

const useMessagesTableData = () => {
  const data = useSelector(templates.getModel)

  const { count, items = [], order = [] } = data ?? {}

  return {
    state: { count, items, order },
  }
}

export const useMessagesTable = state => {
  const { mapSortingPropToQueryParam, search, filter } = state

  const dispatch = useDispatch()

  const columns = getColumns()
  const rowActions = getRowActions()

  const { handleFetchMessagesTemplates } = useMessagesTableMutations()

  const {
    state: { count, items, order },
  } = useMessagesTableData()

  const handleRefetch = React.useCallback(
    ({ limit, department, offset, ordering, search }: TableQuery) =>
      handleFetchMessagesTemplates({
        limit,
        department,
        offset,
        ordering,
        search,
      }),
    [handleFetchMessagesTemplates],
  )

  const handleQueriesUpdate = React.useCallback(
    ({ limit, department, offset, ordering, search }: TableQuery) => {
      dispatch(
        toTemplates(TAB_NAMES.MESSAGES, null, {
          limit,
          department,
          offset,
          ordering,
          search,
        }),
      )
    },
    [dispatch],
  )

  const {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: { headers, model, isFetching },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
    },
  } = useTable({
    columns,
    data: order.map(key => items[key]),
    mapSortingPropToQueryParam,
    pageCount: count,
    filterQuery: filter,
    search,
    fetchAction: handleRefetch,
    updateQueriesAction: handleQueriesUpdate,
  })

  return {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: {
        headers,
        model,
        rowActions,
        isFetching,
      },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
    },
  }
}
